/**
 * KH Consulting theme — minimal JS: mobile nav, header scroll, audit lens tooltips, FAQ accordions
 */
(function () {
  'use strict';

  var auditLensDocBound = false;

  function hideAuditTip(wrap) {
    var trigger = wrap.querySelector('[data-kh-audit-tip-trigger]');
    var tooltip = wrap.querySelector('[role="tooltip"]');
    if (!trigger || !tooltip) return;
    tooltip.setAttribute('hidden', '');
    tooltip.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.removeAttribute('aria-describedby');
    wrap.classList.remove('kh-audit-lens__tip--open');
  }

  function showAuditTip(wrap) {
    var figure = wrap.closest('.kh-audit-lens');
    if (figure) closeAllTipsInFigure(figure);
    var trigger = wrap.querySelector('[data-kh-audit-tip-trigger]');
    var tooltip = wrap.querySelector('[role="tooltip"]');
    if (!trigger || !tooltip) return;
    tooltip.removeAttribute('hidden');
    tooltip.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-describedby', tooltip.id);
    wrap.classList.add('kh-audit-lens__tip--open');
  }

  function closeAllTipsInFigure(figure) {
    figure.querySelectorAll('[data-kh-audit-tip-wrap]').forEach(function (wrap) {
      hideAuditTip(wrap);
    });
  }

  function initMobileNav() {
    var toggles = document.querySelectorAll('[data-kh-menu-open]');
    var nav = document.querySelector('[data-kh-mobile-nav]');
    var closeBtns = document.querySelectorAll('[data-kh-menu-close]');

    if (!nav) return;

    function openNav() {
      nav.classList.add('is-open');
      nav.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }

    function closeNav() {
      nav.classList.remove('is-open');
      nav.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openNav();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeNav();
      });
    });

    nav.addEventListener('click', function (e) {
      if (e.target === nav) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-kh-header]');
    if (!header) return;

    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAuditLensTips(root) {
    var scope = root || document;
    var figures = scope.querySelectorAll('.kh-audit-lens');
    if (!figures.length) return;

    var prefersHover =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    figures.forEach(function (figure) {
      if (figure.getAttribute('data-kh-audit-tips-init') === '1') return;
      figure.setAttribute('data-kh-audit-tips-init', '1');

      figure.querySelectorAll('[data-kh-audit-tip-wrap]').forEach(function (wrap) {
        var trigger = wrap.querySelector('[data-kh-audit-tip-trigger]');
        if (!trigger) return;

        if (prefersHover) {
          wrap.addEventListener('mouseenter', function () {
            showAuditTip(wrap);
          });
          wrap.addEventListener('mouseleave', function () {
            hideAuditTip(wrap);
          });
          trigger.addEventListener('focus', function () {
            showAuditTip(wrap);
          });
          trigger.addEventListener('blur', function (e) {
            var rt = e.relatedTarget;
            if (rt && wrap.contains(rt)) return;
            hideAuditTip(wrap);
          });
        } else {
          trigger.addEventListener('blur', function (e) {
            var rt = e.relatedTarget;
            if (rt && wrap.contains(rt)) return;
            hideAuditTip(wrap);
          });
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var open = trigger.getAttribute('aria-expanded') === 'true';
            if (open) hideAuditTip(wrap);
            else showAuditTip(wrap);
          });
        }
      });
    });

    if (!auditLensDocBound) {
      auditLensDocBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var hit = t.closest('[data-kh-audit-tip-wrap]');
        document.querySelectorAll('[data-kh-audit-tip-wrap]').forEach(function (wrap) {
          if (hit && wrap === hit) return;
          hideAuditTip(wrap);
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.kh-audit-lens').forEach(function (fig) {
          if (fig.querySelector('[data-kh-audit-tip-trigger][aria-expanded="true"]')) {
            closeAllTipsInFigure(fig);
          }
        });
      });
    }
  }

  function initFaqAccordions(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-kh-faq-item]');

    items.forEach(function (item) {
      var btn = item.querySelector('[data-kh-faq-trigger]');
      var panel = item.querySelector('[data-kh-faq-panel]');
      if (!btn || !panel) return;

      var expanded = btn.getAttribute('aria-expanded') === 'true';

      function setExpanded(next) {
        expanded = next;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }

      btn.addEventListener('click', function () {
        setExpanded(!expanded);
      });
    });
  }

  function initAll(root) {
    initMobileNav();
    initHeaderScroll();
    initAuditLensTips(root);
    initFaqAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  window.KHTheme = {
    init: initAll,
    initAuditLensTips: initAuditLensTips,
    initFaqAccordions: initFaqAccordions,
  };
})();
